import React from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import MenuSection from './components/MenuSection';
import Footer from './components/Footer';
import { menuItems, categories } from './data/menu';

const App: React.FC = () => {
  // Group items by category
  const groupedItems = categories.reduce((acc, category) => {
    acc[category] = menuItems.filter(item => item.category === category);
    return acc;
  }, {} as Record<string, typeof menuItems>);

  return (
    <div className="min-h-screen bg-gray-50 font-sans">
      <Navbar />
      <Hero />
      
      <main id="menu" className="bg-gray-50">
        {categories.map((category, index) => (
          <div key={category} className={index % 2 === 0 ? 'bg-white' : 'bg-gray-50'}>
            <MenuSection 
              id={`category-${index}`}
              title={category} 
              items={groupedItems[category] || []} 
            />
          </div>
        ))}
      </main>

      <Footer />
    </div>
  );
};

export default App;
